import { PermissionFromStore, UserStateData } from '@/types/types';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface UserPermissionsStoreActions {
  setId: (id: string | null) => void;
  setWorkspacePermission: (role: PermissionFromStore | null) => void;
  setOrganizationPermission: (role: PermissionFromStore | null) => void;
  setIsEmailVerified: (isEmailVerified: boolean | null) => void;
  setEmail: (email: string | null) => void;
  reset: () => void;
}

const initialState: UserStateData = {
  workspacePermission: null,
  organizationPermission: null,
  userId: null,
  email: '',
  isEmailVerified: null,
};

export const useUserPermissionsStore = create<
  UserPermissionsStoreActions & UserStateData
>()(
  devtools(
    (set) => ({
      ...initialState,
      setId: (id) => set({ userId: id }),
      setWorkspacePermission: (permission) => set({ workspacePermission: permission }),
      setOrganizationPermission: (permission) =>
        set({ organizationPermission: permission }),
      setEmail: (email) => set({ email }),
      reset: () => set(initialState),
      setIsEmailVerified: (isEmailVerified) => set({ isEmailVerified }),
    }),
    { name: 'user-permissions' },
  ),
);
